module.exports = __webpack_public_path__ + "static/media/Badge_SvgExpertCategoriel_SanteFemme.a4d20b8a.png";